import { Button, Checkbox, Modal, message } from "antd";
import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import SwapNew from "../../pages/dashboard-content/Promotion/swap/SwapNew";

const locale = require("react-redux-i18n").I18n;

function ModalSwap(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const profileCountry = useSelector((state) => state.user.profileCountry);
  const { isOpen, onClose, isFree, isAccountId } = props;
  const [isChecked, setIsChecked] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  //eieiei

  return (
    <Modal
      className="w-modal-swap width-modal-swap user user-change"
      closable={true}
      visible={isOpen}
      footer={false}
      onCancel={() => {
        onClose();
      }}
    >
      <SwapNew isAccountId={isAccountId} />
      {/* <div className="px-3">
        <div className="d-flex w-100 fs-14 fw-700 align-items-center mt-5">
          {locale.t("modal_swap_title")} : &nbsp;
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="11"
            viewBox="0 0 10 11"
            fill="none"
          >
            <circle
              cx="5"
              cy="5.5"
              r="5"
              fill={isFree ? "#E3673F" : "#1CB894"}
            />
            <circle cx="5" cy="5.5" r="2.5" fill="white" />
          </svg>
          &nbsp;{isFree ? "Non-Free" : "Free"}
        </div>
        <div className="d-flex justify-content-center text-lightgray-iux  align-items-center flex-column w-100 fs-14 mt-3">
          {isFree
            ? locale.t("swap_none_islamic_free")
            : locale.t("swap_none_free")}
        </div>
        <div className="mt-3 fs-12 text-lightgray mb-5">
          <div>{locale.t("modal_note")} :</div>
          <ul style={{ paddingInlineStart: "20px" }}>
            <li>{locale.t("modal_note_des_1")}</li>
            <li>
              {isFree
                ? locale.t("modal_note_non_free")
                : locale.t("modal_note_des_2")}
              <br />
              {!isFree && (
                <>
                  {locale.t("swaps_are_charged")}:
                  <ul style={{ paddingInlineStart: "20px" }}>
                    <li style={{ listStyleType: "disc" }}>
                      {locale.t("swaps_major")}: USDJPY ({locale.t("only_wed")})
                    </li>
                    <li style={{ listStyleType: "disc" }}>
                      {locale.t("swaps_minor")}: AUDCAD, CADCHF, CADJPY, CHFJPY,
                      GBPAUD, GBPCAD, NZDCHF, USDHKD
                    </li>
                    <li style={{ listStyleType: "disc" }}>
                      {locale.t("swaps_metals")}: (except XAUUSD)
                    </li>
                    <li style={{ listStyleType: "disc" }}>
                      {locale.t("swaps_index")}: DXY
                    </li>
                  </ul>
                </>
              )}
            </li>
          </ul>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button
          className="btn-primary-new-iux"
          onClick={() =>
            window.location.assign(
              `${process.env.REACT_APP_DOMAIN_IUX_COM}/${localStorage.getItem(
                "locale"
              )}/markets#swap`
            )
          }
        >
          {`Swap rates >`}
        </button>
      </div> */}
    </Modal>
  );
}

export default ModalSwap;
